import { Component, ElementRef, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "../../store/app.service";
import { UserRoles } from "../../api/gmi/auth/models/user-info.model";

@Component({
    selector: "gmi-dashboard",
    templateUrl: "dashboard.template.html",
    styleUrls: ["dashboard.style.scss"],
    encapsulation: ViewEncapsulation.None
})
export class DashboardComponent implements OnInit {
    public UserRoles = UserRoles;

    constructor(
        private router: Router,
        private elementRef: ElementRef,
        private appService: AppService
    ) {}

    public ngOnInit() {
        this.appService.loadUserInfo();
        this.router.events.subscribe(_ => {
            this.elementRef.nativeElement.scrollIntoView();
        });
    }
}
